import {Button, Card, Col, Row} from "react-bootstrap";
import React from "react";

const Manual = () => {
    return (
        // <>
        //     {/*<h3 className="mt-4 text-center">คู่มือการใช้งานระบบจองห้องประชุมออนไลน์ (LTIC Booking)</h3>*/}
        // </>

        <Row className="mt-4 mb-4">
            <Col>
                <Card>
                    <Card.Header>
                        <h4><b>วิธีการจองห้อง Smart Classroom & Studio (LTIC Booking)</b></h4>
                    </Card.Header>
                    <Card.Body>
                        <ol>
                            <div style={{color:"red"}}>** จองห้องล่วงหน้าอย่างน้อย 2 วันทําการ และหากต้องการจองห้องเพื่อใช้งานติดต่อกันหลายวัน รบกวนติดต่อล่วงหน้า Email : ltic.psli@kku.ac.th **</div><br/>
                            <li>
                                <div>
                                    เข้าใช้งานระบบจองห้องที่ <a href="https://ltic.kku.ac.th/booking" target="_blank">https://ltic.kku.ac.th/booking</a> -> คลิกปุ่ม KKU LOGIN ซึ่งเป็นการเข้าสู่ระบบของมหาวิทยาลัยขอนแก่น
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-1.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    จะแสดงหน้าหลักเกณฑ์การใช้ห้อง เมื่ออ่านและทำความเข้าใจเรียบร้อยแล้ว -> คลิกยอมรับหลักเกณฑ์การใช้งาน -> คลิกปุ่มตกลง
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-2.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    จะแสดงหน้าข้อมูลห้องทั้งหมด และสามารถเลือกดูตามประเภทห้องได้ -> เลือกห้องที่ต้องการ -> คลิกปุ่มเลือกห้อง
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-3.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    จะแสดงหน้าปฏิทินของห้องที่ท่านเลือก -> คลิกเลือกวันที่ต้องการจอง -> กรอกข้อมูลการจอง -> คลิกปุ่มจองห้อง
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-4.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    เมื่อทำการจองห้องเสร็จสิ้น จะปรากฎการจองของท่านบนปฏิทิน <span style={{color:"red"}}>(หากต้องการยกเลิกการจอง -> คลิกที่การจองของท่าน และคลิกปุ่มลบ จากนั้นจะมี Email แจ้งยกเลิกการจอง)</span>
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-5.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    จากนั้นท่านจะได้รับ Email แจ้งการจองห้องสำเร็จ
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-6.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    เมื่อเจ้าหน้าที่อนุมัติการจองห้องของท่านเรียบร้อยแล้ว ท่านจะได้รับ Email แจ้งยืนยันการจองของท่านได้รับการอนุมัติเรียบร้อย
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-7.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    ที่หน้าปฏิทินของห้องที่ท่านจองในระบบ จะแสดงสถานะการจองห้องของท่านเป็น Approved (อนุมัติเรียบร้อยแล้ว)
                                </div>
                                <Card.Img variant="top" src="/booking/manual/manual-8.png" fluid/>
                            </li>
                            <li>
                                <div>
                                    เมื่อเสร็จสิ้นวันใช้บริการห้อง ขอความอนุเคราะห์ตอบแบบประเมินความพึงพอใจต่อการใช้ห้อง Smart Classroom & Studio (LTIC Booking) ทุกครั้งหลังการใช้บริการห้อง >> <a href="https://forms.gle/5jWYBub725L6zrKc9" target="_blank">แบบประเมินความพึงพอใจ</a>
                                </div>
                            </li>
                        </ol>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}
export default Manual
